import { useIntl } from 'react-intl'
import _get from 'lodash/get';
import Card from '@/entities/Card';
import Button from '@/shared/ui/Button';
import { IconList } from '@/shared/ui/Icons';
import { WorkersChart } from '~/accountingAndAnonymous/Workers';
import { VIEWS, useNavigation } from "@/processes/Router";

type WorkersWidgetProps = {
  className?: string;
}

const WorkersWidget = (props: WorkersWidgetProps) => {
  const { className } = props;
  const { updateURLQueryParams } = useNavigation();
  const intl = useIntl();

  return (
    <Card 
      className={className} 
      title={intl.formatMessage({ id: 'workers' })}
      actions={
        <Button 
          isOverlay={true}
          onClick={() => updateURLQueryParams({ view: VIEWS.WORKERS })}
          prefixIcon={(<IconList/>)}
        >{intl.formatMessage({ id: 'details' })}</Button>
      }
    >
      <WorkersChart/>
    </Card>
  );
}

export default WorkersWidget;
